import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { Admin } from './admin.model'
@Injectable({
  providedIn: 'root'
})
export class AdminService {
selectedAdmin: Admin = {
  userName : '',
  password : '',
  fullName : '',
  contactNumber : '',
  email : '',
};

noAuthHeader = { headers: new HttpHeaders({ 'NoAuth': 'True' }) };
constructor(private http: HttpClient) { }

postAdmin(admin: Admin){
 //console.log('Inside post admin', admin);
  return this.http.post(environment.apiBaseUrl+ '/auth/signup', admin, this.noAuthHeader);
  }
}
